import type { AuditListInput, AuditRepository, TenantContext } from '@zetyar/data-contracts'
import type { AuditLog, UUID } from '@zetyar/domain'
import type { SupabaseClient } from '@supabase/supabase-js'

export function createSupabaseAuditRepository(client: SupabaseClient): AuditRepository {
  return {
    async list(context: TenantContext, { limit }: AuditListInput) {
      const { data, error } = await client
        .from('audit_logs')
        .select('id, actor_membership_id, action, target_type, target_id, detail, created_at, actor:memberships!audit_logs_actor_membership_id_fkey (display_name)')
        .eq('organization_id', context.organizationId)
        .order('created_at', { ascending: false })
        .limit(Math.max(1, Math.min(limit, 200)))

      if (error) throw error

      return (data ?? []).map((item): AuditLog => {
        const actor = item.actor as unknown as { display_name: string } | null
        return {
          id: item.id as UUID,
          organizationId: context.organizationId,
          actorMembershipId: (item.actor_membership_id as UUID | null) ?? null,
          action: item.action as string,
          targetType: item.target_type as string,
          targetId: (item.target_id as UUID | null) ?? null,
          detail: (item.detail as string | null) ?? null,
          createdAt: item.created_at as string,
          actorDisplayName: actor?.display_name ?? null,
        }
      })
    },
  }
}
